export const TICKET_TYPES = {
  CONNECTION_ISSUE: "Connection Issues",
  FINANCE_AND_BILLING: "Finance & Billing",
  OTHER: "Other",
};

export const TICKET_TYPES_OPTIONS = Object.entries(TICKET_TYPES).map(
  ([id, name]) => ({ id, name }),
);
